import { FunctionalComponent } from 'preact'
import { THEME_COLORS } from '@/constants/theme'

export interface SignalBarsProps {
    score: number
    totalBars?: number
    barHeightPercent?: number
    class?: string
    ariaLabelPrefix?: string
}

// Reusable signal strength bar visualization (5 bars, bucketed by score/4 by default)
export const SignalBars: FunctionalComponent<SignalBarsProps> = ({
    score,
    totalBars = 5,
    barHeightPercent = 85,
    class: className = 'flex items-end h-10 w-16 gap-1',
    ariaLabelPrefix = 'Signal strength'
}) => {
    const activeBars = Math.min(totalBars, Math.max(0, Math.ceil(score / 4)))
    const colors = [THEME_COLORS.PURPLE[400], THEME_COLORS.PURPLE[400], THEME_COLORS.PURPLE[500], THEME_COLORS.PURPLE[500], THEME_COLORS.PURPLE[800]]
    return (
        <div
            class={className}
            aria-label={`${ariaLabelPrefix} ${activeBars} of ${totalBars} (score ${score})`}
            title={`Signal score ${score}`}
        >
            {Array.from({ length: totalBars }).map((_, i) => {
                const filled = i < activeBars
                const baseClass = filled ? 'flex-1 rounded-sm transition-colors duration-300' : 'flex-1 rounded-sm transition-colors duration-300 bg-gray-200 dark:bg-gray-700'
                return (
                    <div
                        key={i}
                        class={baseClass}
                        style={{
                            height: `${barHeightPercent}%`,
                            minWidth: '5px',
                            backgroundColor: filled ? colors[i] : undefined
                        }}
                    />
                )
            })}
        </div>
    )
}

export default SignalBars
